__webpack_require__.p = "/25-5-CLOCK/";